import { RpcService } from 'rpc';
import { I18NSvcReturn } from '../interfaces';

export type SorSS = string[] | string[][];

export interface INLSService extends RpcService {
	get_i18n_text(params: { namespace: string }): Promise<I18NSvcReturn>;
	get_i18n_namespaces(): Promise<SorSS>;
	get_lpl1_text(): Promise<I18NSvcReturn>;
}

export const svc: INLSService = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,

	services: {
		get_i18n_text: {
			parameters: [
				{
					name: 'namespace',
					type: 'string',
					optional: false
				}
			]
		},
		get_i18n_namespaces: {
			parameters: []
		},
		get_lpl1_text: {
			parameters: []
		}
	}
}) as INLSService;

export default svc;
